import React, { Component } from 'react';
import './App.css';
import './About.css';

class About extends Component {
  render() {
    return (
      <div id="about">
          <div className="container">
            
            <div className="aboutRow clear">
              <h2>About Us</h2>
              <div className="dash"></div>
              <p>Zygous Labs is an online biomedical research community that promotes collaboration and innovation. Our platform streamlines lab life by supplying scientists with tools to manage daily operations, crowdsource for opinions, and build collaborations without boundaries. Zygous Labs is committed to enhancing the quality of life for scientists by continuing to develop solutions to unmet needs in the academic space.     </p>
            </div>

            <div className="aboutRow clear">
              <h2>Our Mission</h2>
              <div className="dash"></div>
              <p>Zygous Labs is dedicated to forming the largest proactive community of biomedical researchers while promoting innovation through collaboration and developing creative technology solutions to unmet needs in the life science industry. </p>
            </div>

          </div>
      </div>

    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js